(
    function (skyward, $, undefined)
    {
        skyward.studentguardian = skyward.studentguardian || {};

        skyward.studentguardian.addNameAddress = function ()
        {
            var nameID = $("#NameIDHidden").val();
            var nameIDForReference = $("#NameIDForReferenceHidden").val();
            var addressID = $("#AddressIDHidden").val();
            var districtID = $("#DistrictIDHidden").val();
            var schoolYearID = $("#SchoolYearIDHidden").val();
            var entityID = $("#EntityIDHidden").val();
            var displayAddressRangeDefaultsWarning = true;

            $.ajax({
                url: skyward.global.virtualDir + "Family/StudentGuardian/RetreiveDataForAddMeetAddress",
                type: "POST",
                dataType: "json",
                data:
                {
                    addressID: addressID,
                    nameID: nameID,
                    nameIDForReference: nameIDForReference,
                    districtID: districtID,
                    schoolyearid: schoolYearID,
                    entityid: entityID,
                    displayAddressRangeDefaultsWarning: displayAddressRangeDefaultsWarning
                },
                success: function (data)
                {
                    var workflowData =
                    {
                        "Workflow.AddressID": data["AddressID"],
                        "Workflow.AddressID_SecurityHash": data["AddressIDSecurityHash"],
                        "Workflow.NameID": data["NameID"],
                        "Workflow.NameID_SecurityHash": data["NameIDSecurityHash"],
                        "Workflow.NameIDForReference": data["NameIDForReference"],
                        "Workflow.NameIDForReference_SecurityHash": data["NameIDForReferenceSecurityHash"],
                        "Workflow.DistrictID": data["DistrictID"],
                        "Workflow.DistrictID_SecurityHash": data["DistrictIDSecurityHash"],
                        "Workflow.SchoolYearID": data["SchoolYearID"],
                        "Workflow.SchoolYearID_SecurityHash": data["SchoolYearIDSecurityHash"],
                        "Workflow.EntityID": data["EntityID"],
                        "Workflow.EntityID_SecurityHash": data["EntityIDSecurityHash"],
                        "Workflow.DisplayAddressRangeDefaultsWarning": data["DisplayAddressRangeDefaultsWarning"],
                        "Workflow.DisplayAddressRangeDefaultsWarning_SecurityHash": data["DisplayAddressRangeDefaultsWarningSecurityHash"]
                    };

                    skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Demographics/NameAddress/Add", null, workflowData, null, skyward.studentguardian.refreshAddressQuickEntry);
                }
            });
        };

        skyward.studentguardian.refreshAddressQuickEntry = function()
        {
            return $.ajax({
                url: skyward.global.virtualDir + "Family/StudentGuardian/GetAddressChildRecordQuickEntry/",
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    displayaddressnameID: $("#NameIDHidden").val()
                },
                success: function (data)
                {
                    $("#AddressViewQuickEntryBorder").html(data);
                    //Controller setting all checkboxes to disabled, this fixes that
                    $("#AddressViewQuickEntryBorder").find("input").each(function (index, element)
                    {
                        $(element).prop('disabled', $(element).prop("checked"));
                    });
                }
            });
        };

        // Event handlers
        var events =
        {
            "addNameAddress": skyward.studentguardian.addNameAddress
        };
        skyward.events.registerEvents("studentguardian", events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);